import { type ReactNode, useState } from 'react';
import { type FormsRegister, FormsRegisterContext } from './context.ts';

interface FormsRegisterProviderProps {
  children: ReactNode;
}

export function FormsRegisterProvider({
  children,
}: FormsRegisterProviderProps) {
  const [formsRegister, setFormsRegister] = useState<FormsRegister>(() => ({}));
  return (
    <FormsRegisterContext.Provider value={{ formsRegister, setFormsRegister }}>
      {children}
    </FormsRegisterContext.Provider>
  );
}
